exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-6b657d43]{color:#2aacea}#login_navbar[data-v-6b657d43]{padding:15px;display:flex;justify-content:flex-end}#login_navbar #login-button[data-v-6b657d43]{margin-right:10px}", ""]);

// exports
